import { AbstractPmsApiService } from './abstract.service';
import { Coupon } from '../models';

/**
 * @class CouponPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<Coupon>}
 */
export class CouponPmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/coupon(/:id)';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {Coupon}
     * @protected
     */
    newModel(attributes) {

        return new Coupon(attributes);
    }

    /**
     * @param {Object} params
     * @returns {Promise.<PaginationCollection<Country>>}
     */
    get (params = {}) {

        const url = this.url();
        const ignoreLB = params.hasOwnProperty('searchValue');
        return this.http
            .get(url, {
                headers: this.authHeaders,
                params,
                ignoreLoadingBar: ignoreLB
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {Coupon} coupon
     * @returns {Promise.<Coupon>}
     */
    create(coupon) {

        const url = this.url();

        return this.http
            .post(url, coupon, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {Coupon} coupon
     * @returns {Promise.<Coupon>}
     */
    update(coupon) {

        const url = this.url({id: coupon.id});

        return this.http
            .put(url, coupon, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {Coupon} coupon
     * @returns {Promise.<boolean>}
     */
    delete(coupon) {

        const url = this.url({id: coupon.id});

        return this.http
            .delete(url, {
                headers: this.authHeaders
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }

    /**
     * Request for unique property ID
     *
     * @returns {Promise.<Object>}
     */
    uniqueId() {

        return this.http
            .get(this.url() + '/unique-id', {
                headers: this.authHeaders
            })
            .then(this.getDataExtractor())
            .catch(this.getErrorHandler());
    }

    /**

     * @param {Integer} couponId
     * @param {Object} params
     */
    show(couponId, params = {}) {

        const url = this.url({
            id: couponId
        });

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     *
     * @param coupon
     * @return {*}
     */
    canDelete(coupon) {

        const url = this.url({
            id: coupon.id
        }) + '/can-delete';

        return this.http
            .get(url, {
                headers: this.authHeaders
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/coupon.service.js